import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { environment } from '@resume-portal/environment'
import { axios } from '@resume-portal/lib'
import { IServicePlan } from '@resume-portal/models'
import { servicePlanStore } from '@resume-portal/stores/service-plan-store'

class ServicePlanService {
  private readonly baseUrl = `${environment.AUTH_API_URL}/ServicePlan`

  getServicePlans(): Observable<IServicePlan[]> {
    return axios.get<IServicePlan[]>(this.baseUrl).pipe(
      map(({ data }) => {
        servicePlanStore.dispatch({ servicePlans: data })
        return data
      })
    )
  }
}

export const servicePlanService = new ServicePlanService()
